import React, { FC } from "react"

import { AuthorFragmentFragment } from "@graphqlTypes"

import Hero from "@components/Hero/Hero"
import Icon, { ICON_TYPES } from "@components/Icon/Icon"
import ImageAboveFold from "@components/ImageAboveFold/ImageAboveFold"
import PostsNav from "@templates/posts/components/PostsNav/PostsNav"

import { AuthorPageHeroHEADER } from "./AuthorPageHero.styles"

const AuthorPageHero: FC<AuthorFragmentFragment> = ({
  bio,
  name,
  twitter,
  url,
  image,
}) => {
  return (
    <Hero>
      <div>
        <PostsNav currentCategorySlug="all" />
        <AuthorPageHeroHEADER>
          <div className="container">
            <div className="grid">
              <div className="image-column column column--6-13-S column--1-5-M column--1-5-L">
                {image?.imgixImage?.gatsbyImageData && (
                  <ImageAboveFold
                    alt={`Photo: ${name}`}
                    aspectRatio={1}
                    imageData={image.imgixImage.gatsbyImageData}
                  />
                )}
                {(twitter || url) && (
                  <div className="social-links">
                    {twitter && (
                      <a aria-label={`Follow ${name} on X`} href={`https://www.twitter.com/${twitter}`} target="_blank">
                        <svg className="x-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                          <path d="M11.3723 8.72382L17.4434 1.66663H16.0047L10.7332 7.79429L6.5228 1.66663H1.66663L8.03355 10.9327L1.66663 18.3333H3.10537L8.67228 11.8623L13.1187 18.3333H17.9749L11.3719 8.72382H11.3723ZM9.40172 11.0144L8.75662 10.0917L3.62377 2.74969H5.8336L9.97587 8.67491L10.621 9.59761L16.0054 17.2995H13.7956L9.40172 11.0147V11.0144Z" fill="var(--color--charcoal-1200)" />
                        </svg>
                      </a>
                    )}
                    {url && (
                      <a aria-label={`Follow ${name}'s personal link`} href={url} target="_blank">
                        <Icon color="var(--color--charcoal-1200)" size="24px" type={ICON_TYPES["link"]} />
                      </a>
                    )}
                  </div>
                )}
              </div>
              <div className="text-column column column--6-13-S column--5-13-M column--5-13-L">
                <h4 className="overline type--mono-S color--text-light">Blog Author</h4>
                <div>
                  <h1>{name === "Help Scout" ? "Posts by Help Scout" : name}</h1>
                  {bio?.childMarkdownRemark?.html && (
                    <div
                      className="bio"
                      dangerouslySetInnerHTML={{ __html: bio.childMarkdownRemark.html }}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </AuthorPageHeroHEADER>
      </div>
    </Hero>
  )
}

export default AuthorPageHero
